export default [
  {
    path: '/feedback-manage',
    name: 'feedback-manage',
    component: resolve => require(['views/feedback-manage'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/pt-feedback-table',
    name: 'pt-feedback-table',
    component: resolve => require(['views/pt-feedback-table'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/feedback-manage/pt-feedback-detail/:id',
    name: 'pt-feedback-detail',
    component: resolve => require(['views/pt-feedback-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '意见反馈管理/意见反馈详情' }
  }
]
